import { rollbackBooking, runWalkInCascade } from '../../lib/walk-in-cascade.js';
import { useWalkInWizard } from '../../stores/walkIn.js';

/**
 * HM-075 — Modal recovery per errori cascade walk-in.
 * Opzioni: Retry / Skip / Cambia metodo (solo payment) / Annulla.
 */
export function ErrorRecovery() {
  const wizard = useWalkInWizard();
  const { cascade, setCascade, setPayment, payment, setStep } = wizard;
  if (!cascade.error) return null;

  const isPaymentStage = cascade.error.stage === 'payment';
  const isFiscalStage = cascade.error.stage === 'fiscal';
  const isAccessCodeStage = cascade.error.stage === 'access_code';

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      data-testid="error-recovery"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.6)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 1100,
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: 16,
          borderRadius: 8,
          width: 'min(440px, 96vw)',
        }}
      >
        <h3 style={{ margin: 0, color: '#dc2626' }}>Errore: {cascade.error.stage}</h3>
        <p style={{ margin: '8px 0', fontSize: 13 }}>{cascade.error.message}</p>
        {isAccessCodeStage && (
          <p data-testid="knx-down-hint" style={{ fontSize: 12, color: '#7c2d12' }}>
            Bus KNX: codice non scritto. Procedere con consegna chiave manuale.
          </p>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
          <button
            type="button"
            data-testid="recovery-retry"
            onClick={() => {
              setCascade({ error: null });
              void runWalkInCascade(wizard);
            }}
          >
            Riprova
          </button>
          <button
            type="button"
            data-testid="recovery-skip"
            onClick={() => {
              setCascade({ error: null, currentStep: 'done' });
            }}
          >
            Salta {isFiscalStage ? '(stampa dopo)' : isAccessCodeStage ? '(consegna manuale)' : ''}
          </button>
          {isPaymentStage && (
            <button
              type="button"
              data-testid="recovery-change-method"
              onClick={() => {
                setPayment(payment === 'card' ? 'cash' : 'card');
                setCascade({ error: null });
                setStep(3);
              }}
            >
              Cambia metodo
            </button>
          )}
          <button
            type="button"
            data-testid="recovery-abort"
            onClick={async () => {
              setCascade({ error: null, running: true });
              await rollbackBooking(wizard);
              setCascade({ running: false, currentStep: 'idle', bookingId: null });
              wizard.close();
            }}
          >
            Annulla walk-in
          </button>
        </div>
      </div>
    </div>
  );
}
